import config from "../../config";
import {Customer, Session} from "./customer";
import {CustomerServiceError} from "./error";

export async function updateAvatar(image: Blob, session: Session): Promise<Customer> {
  const data = new FormData();
  data.append("image", image);
  const result = await fetch(`${config.customerServiceUrl}/customer/${session.customerId}/avatar`, {
    body: data,
    cache: 'no-cache',
    headers: {
      'NY-SESSION-TOKEN': `${session.token}`,
    },
    method: 'PUT',
  });

  const json = await result.json();
  if (json.error) {
    throw new Error("[customer-service] error while update avatar: " + json.error)
  }

  if (!result.ok) {
    throw new CustomerServiceError(json);
  }

  return new Customer(json);
}
